export default __webpack_public_path__ + "static/media/redarrow.f889ad06.svg";